<template>
  <router-view />
</template>

<style lang="scss">
.fixed-box {
  // position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  overflow: hidden;
}
</style>
